import React, { useEffect, useRef } from 'react';
import './Pricing.css';

const Pricing = () => {
  const pricingRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-active');
          } else {
            entry.target.classList.remove('reveal-active');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = pricingRef.current.querySelectorAll('.animate-pricing');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const pricingData = [
    {
      title: "Affordable Care",
      price: "₹200",
      desc: "Starting from just per consultation for basic home healthcare.",
      icon: "Rs",
      type: "basic"
    },
    {
      title: "Standard Doctor Visits",
      price: "₹1000",
      desc: "Comprehensive doctor home visits available up to this range.",
      icon: "👨‍⚕️",
      type: "standard"
    },
    {
      title: "Value For Money",
      price: "Transparent",
      desc: "No hidden charges. Pay only what is shown upfront.",
      icon: "➕",
      type: "value"
    }
  ];

  return (
    <section className="pricing-section" id="portal" ref={pricingRef}>
      <div className="pricing-bg-decor"></div>
      
      <div className="pricing-header animate-pricing">
        <span className="pricing-tag">Pricing Plans</span>
        <h2>Affordable Home <span>Healthcare Pricing</span></h2>
        <div className="header-underline"></div>
      </div>

      <div className="pricing-grid">
        {pricingData.map((plan, index) => (
          <div key={index} className={`pricing-card animate-pricing delay-${index}`}>
            <div className="plan-glow"></div>
            <div className="plan-icon">{plan.icon === "Rs" ? <span className="rs-icon">Rs</span> : plan.icon}</div>
            <h3>{plan.title}</h3>
            <div className="price-tag">
              <span className="amount">{plan.price}</span>
              {plan.price.includes('₹') && <span className="period">/ visit</span>}
            </div>
            <p>{plan.desc}</p>
            <button className="plan-btn">Book Now</button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Pricing;